import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "~/shared/lib/utils";

const inputVariants = cva(
    "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/50 dark:aria-invalid:ring-destructive/60",
    {
        variants: {
            variant: {
                default: "focus-visible:border-input focus-visible:ring-1 focus-visible:ring-violet-500/40",
                success:
                    "border-success focus-visible:border-success focus-visible:ring-1 focus-visible:ring-success/40",
                error: "border-error focus-visible:border-error focus-visible:ring-1 focus-visible:ring-error/40",
                warning:
                    "border-warning focus-visible:border-warning focus-visible:ring-1 focus-visible:ring-warning/40",
                info: "border-info focus-visible:border-info focus-visible:ring-1 focus-visible:ring-info/40",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

function Input({
    className,
    variant,
    type,
    ref,
    ...props
}: React.ComponentProps<"input"> & VariantProps<typeof inputVariants>) {
    return (
        <input
            ref={ref}
            type={type}
            data-slot="input"
            className={cn(inputVariants({ variant, className }))}
            {...props}
        />
    );
}

export { Input, inputVariants };
